<template>
  <dialog id="deleteModal" class="delete-modal" ref="deleteModal" v-if="isOpen" @close="closeModal">
    <button class="close-button" aria-label="Close modal" @click="closeModal"></button>
    <div>
      <h4 class="delete-modal__heading">
        Delete this item?
      </h4>
      <button class="button" @click="closeModal">
        Cancel
      </button>
      <button class="button button--primary" @click="deleteItem">
        Delete
      </button>
    </div>
  </dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object
    }
  },
  watch: {
    isOpen(value) {
      this.$nextTick(() => {
        if (value) {
          const modal = this.$refs.deleteModal;
          modal.showModal();
          modal.addEventListener('close', this.closeModal);
        }
      });
    },
    item(value) {
      if (value) {
        this.item = value;
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    deleteItem() {
      this.$refs.deleteModal.close();
      this.$emit('delete', this.item);
      this.closeModal();
    }
  }
};
</script>
